// src/app/core/guards/direct-debit.guard.ts

import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { PermissionService } from '@core/services/permission.service';
import { guardWithProfile } from './guard.utils';

/**
 * CanMatchFn — gates the /direct-debit section (Sigurimet → Direct Debit).
 * Requires `directdebit.view` or `directdebit.manage` (admin.full_access bypasses).
 */
export const directDebitGuard: CanMatchFn = () => {
  const perm = inject(PermissionService);
  return guardWithProfile(() => perm.canViewDirectDebit(), '/dashboard');
};

/**
 * CanMatchFn — gates "Hyrja e shënimeve" (generate and save a batch), which
 * needs `directdebit.manage`. Viewers land on "Shfletimi dhe Shtypja".
 */
export const directDebitManageGuard: CanMatchFn = () => {
  const perm = inject(PermissionService);
  return guardWithProfile(() => perm.canManageDirectDebit(), '/direct-debit/shfletimi');
};
